import dayjs from 'dayjs'

export function timestampToTime(
  time,
  format= 'YYYY-MM-DD HH:mm:ss'
) {
  if (!time || time === 'undefined' || time === 'null') return ''
  return dayjs(time).format(format)
}
export function formatDay(value) {
  return timestampToTime(value, "YYYY-MM-DD HH:mm:ss");
}
export function formatDayYYYYMMDD(value) {
  return timestampToTime(value, "YYYY-MM-DD");
}
export function formatDayCN(value) {
  return timestampToTime(value, "YYYY年MM月DD日");
}

// 获取昨天
export function getYesterday() {
  return dayjs().subtract(1, 'day').format('YYYY-MM-DD')
}
// 获取最近7天
export function getSevenDays() {
  return dayjs().subtract(7, 'day').format('YYYY-MM-DD')
}
// 获取最近30天
export function getThirtyDays() {
  return dayjs().subtract(30, 'day').format('YYYY-MM-DD')
}